import { render, staticRenderFns } from "./SocialProfilePicture.vue?vue&type=template&id=7957681c&"
import script from "./SocialProfilePicture.vue?vue&type=script&lang=js&"
export * from "./SocialProfilePicture.vue?vue&type=script&lang=js&"
import style0 from "./SocialProfilePicture.vue?vue&type=style&index=0&id=7957681c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports